import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import actions from "./actions";
var getTotalValues = (products, fields) => {
  var totalValues = {};
  var productsArray = Object.values(products).flat().filter(x => !x.isDefault);
  fields.forEach(field => {
    totalValues[field] = parseFloat(productsArray.reduce((accumulator, product) => {
      return accumulator + product.quantity * product[field];
    }, 0)).toFixed(2);
  });
  return totalValues;
};
export var setCurrentPage = payload => ( /*#__PURE__*/function () {
  var _thunk = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setCurrentPage.receive(payload));
  });
  function thunk(_x) {
    return _thunk.apply(this, arguments);
  }
  return thunk;
}());
export var setPrevPageTotal = payload => ( /*#__PURE__*/function () {
  var _thunk2 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setPrevPageTotal.receive(payload));
  });
  function thunk(_x2) {
    return _thunk2.apply(this, arguments);
  }
  return thunk;
}());
export var setProductCatalog = payload => ( /*#__PURE__*/function () {
  var _thunk3 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setProductCatalog.receive(payload));
  });
  function thunk(_x3) {
    return _thunk3.apply(this, arguments);
  }
  return thunk;
}());
export var setSectionCatalog = payload => ( /*#__PURE__*/function () {
  var _thunk4 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setSectionCatalog.receive(payload));
  });
  function thunk(_x4) {
    return _thunk4.apply(this, arguments);
  }
  return thunk;
}());
export var setCrossSellProductsMiniCart = payload => ( /*#__PURE__*/function () {
  var _thunk5 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setCrossSellProductsMiniCart.receive(payload));
  });
  function thunk(_x5) {
    return _thunk5.apply(this, arguments);
  }
  return thunk;
}());
export var setCrossSellProductsModalFirst = payload => ( /*#__PURE__*/function () {
  var _thunk6 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setCrossSellProductsModalFirst.receive(payload));
  });
  function thunk(_x6) {
    return _thunk6.apply(this, arguments);
  }
  return thunk;
}());
export var setCrossSellProductsModalSecond = payload => ( /*#__PURE__*/function () {
  var _thunk7 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setCrossSellProductsModalSecond.receive(payload));
  });
  function thunk(_x7) {
    return _thunk7.apply(this, arguments);
  }
  return thunk;
}());
export var setFilters = payload => ( /*#__PURE__*/function () {
  var _thunk8 = _asyncToGenerator(function* (dispatch) {
    var stickersFilter = payload.ls_dish_stickers;
    var correlatedFilters = Object.keys(stickersFilter.correlated_filters);
    var activeCorrelatedFilters = stickersFilter.values.filter(x => correlatedFilters.includes(x));
    var filterToDisable = Object.entries(stickersFilter.correlated_filters).filter(x => activeCorrelatedFilters.includes(x[0])).map(x => x[1]).flat();
    var newActiveFilters = stickersFilter.values.length > 0 ? stickersFilter.values.filter(x => !filterToDisable.includes(x)) : stickersFilter.disabled_filters;
    var payloadUpdated = _objectSpread(_objectSpread({}, payload), {}, {
      ls_dish_stickers: _objectSpread(_objectSpread({}, stickersFilter), {}, {
        values: [...newActiveFilters],
        disabled_filters: [...filterToDisable]
      })
    });
    dispatch(actions.setFilters.receive(payloadUpdated));
  });
  function thunk(_x8) {
    return _thunk8.apply(this, arguments);
  }
  return thunk;
}());
export var setMemberAttributeFilters = payload => ( /*#__PURE__*/function () {
  var _thunk9 = _asyncToGenerator(function* (dispatch, getState) {
    var {
      catalog
    } = getState();
    var newFilters = _objectSpread(_objectSpread({}, catalog.filters), {}, {
      member_attribute_availability: _objectSpread(_objectSpread({}, catalog.filters.member_attribute_availability), {}, {
        values: payload
      })
    });
    dispatch(actions.setFilters.receive(newFilters));
  });
  function thunk(_x9, _x10) {
    return _thunk9.apply(this, arguments);
  }
  return thunk;
}());
export var resetFilters = () => ( /*#__PURE__*/function () {
  var _thunk10 = _asyncToGenerator(function* (dispatch, getState) {
    var {
      catalog
    } = getState();
    var stickersFilter = catalog.filters.ls_dish_stickers;
    var payloadUpdated = _objectSpread(_objectSpread({}, catalog.filters), {}, {
      ls_dish_stickers: _objectSpread(_objectSpread({}, stickersFilter), {}, {
        values: [],
        disabled_filters: []
      })
    });
    dispatch(actions.setFilters.receive(payloadUpdated));
  });
  function thunk(_x11, _x12) {
    return _thunk10.apply(this, arguments);
  }
  return thunk;
}());
export var setFilterPanel = payload => ( /*#__PURE__*/function () {
  var _thunk11 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setFilterPanel.receive(payload));
  });
  function thunk(_x13) {
    return _thunk11.apply(this, arguments);
  }
  return thunk;
}());
export var setLastModalOpenSetter = payload => ( /*#__PURE__*/function () {
  var _thunk12 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setLastModalOpenSetter.receive(payload));
  });
  function thunk(_x14) {
    return _thunk12.apply(this, arguments);
  }
  return thunk;
}());
export var setMainMyoModalOpen = payload => ( /*#__PURE__*/function () {
  var _thunk13 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.setMainMyoModalOpen.receive(payload));
  });
  function thunk(_x15) {
    return _thunk13.apply(this, arguments);
  }
  return thunk;
}());
export var toggleFilterPanelOpen = () => ( /*#__PURE__*/function () {
  var _thunk14 = _asyncToGenerator(function* (dispatch, getState) {
    var {
      catalog
    } = getState();
    var filterPanel = catalog.filterPanel;
    var payload = _objectSpread(_objectSpread({}, filterPanel), {}, {
      isOpen: !filterPanel.isOpen
    });
    dispatch(actions.setFilterPanel.receive(payload));
  });
  function thunk(_x16, _x17) {
    return _thunk14.apply(this, arguments);
  }
  return thunk;
}());
export var setMyoSelection = payload => ( /*#__PURE__*/function () {
  var _thunk15 = _asyncToGenerator(function* (dispatch) {
    var calculatedFields = ["price", "ls_co2", "ls_carboidrati", "ls_zuccheri", "ls_grassi", "ls_grassi_saturi", "ls_proteine", "ls_fibre"];
    var totalValues = getTotalValues(payload.products, calculatedFields);
    var productsFlat = Object.values(payload.products).flat();
    var payloadUpdated = _objectSpread(_objectSpread(_objectSpread({}, payload), totalValues), {}, {
      productsFlat: productsFlat
    });
    dispatch(actions.setMyoSelection.receive(payloadUpdated));
  });
  function thunk(_x18) {
    return _thunk15.apply(this, arguments);
  }
  return thunk;
}());
export var resetMyoSelection = () => ( /*#__PURE__*/function () {
  var _thunk16 = _asyncToGenerator(function* (dispatch) {
    var payload = {
      products: {
        mainSku: []
      },
      productsFlat: [],
      options: [],
      originalProduct: null,
      price: 0
    };
    dispatch(actions.setMyoSelection.receive(payload));
  });
  function thunk(_x19) {
    return _thunk16.apply(this, arguments);
  }
  return thunk;
}());